import { memo } from 'react';

import {
  Users,
  Warning,
} from '../../assets/js/svg/gui';
import {
  useTownAssets,
  useSingleCase,
} from '../../stores';
import pastDateDisplay from '../../utils/dateTime/pastDateDisplay';
import CategoryIcon from '../CategoryIcon';
import { Row } from '../display';
import {
  CsLvlColorDiv,
} from '../generic';

const CaseInfo = memo(
  () => {
    const { thisCase } = useSingleCase();
    const { assets } = useTownAssets();
    const {
      ready,
      ccatCode,
      cDatim1,
      csLvl,
      csClose,
      csCancel,
      csHold,
      csBtwnUsrs,
      csUsrsCflct,
      csDeath,
      csVlnc,
      csWounds,
      csWeapon,
    } = thisCase;
    let {
      csUsersCnt,
      csUsersDone,
      csUsersSupport,
    } = thisCase;
    const { translate } = assets;

    if (!ready) {
      return (
        <div className="bg-pxDarkBg1 h-15 w-full p-1.5 flex items-center text-sm text-pxAccentBlue">
          {/* Loading state */}
        </div>
      );
    }

    const categoryTranslated = (ccatCode)
      ? translate(ccatCode, 'userMainMenu')
      : translate('notSelected');

    // Compile the users status
    csUsersSupport = csUsersSupport || 0;
    csUsersCnt = csUsersCnt || 0;
    csUsersDone = csUsersDone || 0;
    csUsersCnt -= csUsersSupport;
    const activeUsers = csUsersCnt - csUsersDone;
    let users = '';
    let comma;
    if (activeUsers) {
      users = `: ${activeUsers} ${
        translate((activeUsers > 1) ? 'activeMultiple' : 'activeSingle')
      }`;
      comma = true;
    }
    if (csUsersDone) {
      if (comma) users += ', ';
      else users += ': ';

      users += `${csUsersDone} ${
        translate((csUsersDone > 1) ? 'endedMultiple' : 'ended')
      }`;
    }

    // Compile the list of risks
    const risks = [];
    if (csDeath) risks.push(translate('death'));
    if (csWeapon) risks.push(translate('weapons'));
    if (csWounds) risks.push(translate('wounds'));
    if (csVlnc) risks.push(translate('violence'));

    const dividerClassName = 'w-0.5 pt-2 pb-2';
    const dividerInnerClassName = 'w-full h-full bg-pxAccentBlue opacity-30';

    return (
      <Row className="bg-pxDarkBg1 h-15 w-full p-1.5 start text-sm text-pxAccentBlue">
        {/* Category color indicator */}
        <CsLvlColorDiv
          csLvl={csLvl}
          csClose={csClose}
          csCancel={csCancel}
          csHold={csHold}
          csBtwnUsrs={csBtwnUsrs}
          csUsrsCflct={csUsrsCflct}
          className="w-2 h-full"
        />

        {/* Category icon */}
        <div className="h-12 w-12 bg-white p-1 flex justify-center items-center">
          <CategoryIcon
            category={ccatCode}
            className="h-full w-full fill-black"
          />
        </div>

        {/* Category and start time */}
        <div className="flex flex-col justify-start items-start px-1.5 whitespace-nowrap">
          <span className="whitespace-nowrap mr-1">
            <b>{categoryTranslated}</b>
          </span>
          <span className="whitespace-nowrap mr-1">
            {`${translate('start')}: `}
            {pastDateDisplay(cDatim1)}
          </span>
        </div>

        {/* Vertical divider */}
        <div className={dividerClassName}>
          <div className={dividerInnerClassName} />
        </div>

        {/* Users and risks information */}
        <div className="flex flex-col justify-start items-start px-1.5 whitespace-nowrap">
          <Row start className="whitespace-nowrap">
            <Users className="h-3.5 fill-pxAccentBlue mr-1" />
            <span>{users}</span>
          </Row>

          {(risks.length)
            ? (
                <Row start className="whitespace-nowrap">
                  <Warning className="h-3.5 fill-pxCaseOrangeLeft mr-1" />
                  <span className="text-pxCaseOrangeLeft mr-1">
                    {translate('dangers')}
                    :
                  </span>
                  <span>
                    {risks.map((risk, index) => ((index) ? `, ${risk}` : `${risk}`))}
                  </span>
                </Row>
              )
            : (
                <div className="h-3.5" />
              )}
        </div>
      </Row>
    );
  },
);
CaseInfo.displayName = 'CaseInfo';

CaseInfo.propTypes = {
};

export default CaseInfo;
